var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "hotel",
      class: { open: _vm.open, excluded: !_vm.included },
    },
    [
      !_vm.previewing
        ? _c(
            "div",
            { staticClass: "box" },
            [
              !_vm.updating
                ? _c("check-box", {
                    staticClass: "dark-icon",
                    attrs: { value: _vm.included, "check-box-value": true },
                    on: {
                      input: function ($event) {
                        return _vm.$emit("toggle")
                      },
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  })
                : _c("rbv-loading", { attrs: { "rb-class": "small" } }),
            ],
            1
          )
        : _vm._e(),
      !_vm.open
        ? [
            _c(
              "div",
              { staticStyle: { position: "relative" } },
              [
                _c("hotel-image", {
                  staticClass: "image",
                  attrs: {
                    image: _vm.hotel.company.image
                      ? _vm.hotel.company.image.url
                      : "",
                  },
                  on: { click: _vm.toggle },
                }),
                _vm.isClosed
                  ? _c("div", { staticClass: "hotelClosed" }, [
                      _vm._v(" CLOSED "),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "columns", on: { click: _vm.toggle } },
              [
                _c(
                  "div",
                  { staticClass: "main column sm" },
                  [
                    _c("div", { staticClass: "hotel-name-container" }, [
                      _c(
                        "div",
                        {
                          staticClass: "hotel-name label",
                          class: { isClosed: _vm.isClosed },
                        },
                        [_vm._v(" " + _vm._s(_vm.hotel.company.name) + " ")]
                      ),
                      _vm.sustainability
                        ? _c("div", { staticClass: "sustainability" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.sustainability,
                                alt: "Sustainable",
                                loading: "eager",
                              },
                            }),
                          ])
                        : _vm._e(),
                    ]),
                    _vm.hasColumn("rating")
                      ? _c(
                          "rating",
                          {
                            staticClass: "data",
                            attrs: { rate: _vm.hotel.rating },
                          },
                          [
                            _vm._v("  ·  "),
                            _vm.hasColumn("address")
                              ? [_vm._v(" " + _vm._s(_vm.address) + " ")]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm.hasColumn("address")
                      ? _c("div", { staticClass: "data hotel-type" }, [
                          _c("div", { staticClass: "address" }, [
                            _vm._v(_vm._s(_vm.address)),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._l(_vm.columns, function (column) {
                  return [
                    _vm.hasColumn(column.id) ||
                    (column.id === "code" && _vm.includedCode)
                      ? _c(
                          "div",
                          {
                            key: column.id,
                            staticClass: "column",
                            class: column.id,
                          },
                          [
                            column.id !== "amenities" && column.id !== "code"
                              ? _c("span", { staticClass: "label" }, [
                                  _vm._v(" " + _vm._s(column.text) + " "),
                                ])
                              : _vm._e(),
                            column.id === "distanceMi"
                              ? _c("span", { staticClass: "data" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getValue(column.key).toFixed(2)
                                      ) +
                                      " Mi "
                                  ),
                                ])
                              : column.id === "amenities"
                              ? _c("amenities", {
                                  staticClass: "data",
                                  attrs: { amenities: _vm.amenities },
                                })
                              : column.id === "code"
                              ? [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.includedCode.text) + " "
                                    ),
                                  ]),
                                  _c("span", { staticClass: "data" }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.includedCodeValue) + " "
                                    ),
                                  ]),
                                ]
                              : _c("span", { staticClass: "data" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.getValue(column.key) || "-") +
                                      " "
                                  ),
                                ]),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "sm rate column", on: { click: _vm.toggle } },
              [
                _c(
                  "div",
                  { staticClass: "label" },
                  [
                    _vm.bestRate && _vm.view.showRateTypes
                      ? [_vm._v(" " + _vm._s(_vm.bestRate.type) + " ")]
                      : _vm._e(),
                    _vm._v(" Pref. rate "),
                  ],
                  2
                ),
                _c("div", { staticClass: "data" }, [
                  _vm.bestRate
                    ? _c("span", { staticClass: "value" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.bestRate.rate) +
                            " " +
                            _vm._s(_vm.hotel.currency) +
                            " "
                        ),
                      ])
                    : _vm.showDynamicRate
                    ? _c("span", { staticClass: "value bestRate" }, [
                        _c("span", [
                          _vm._v(" " + _vm._s(_vm.hotel.dynamicRate) + "%"),
                        ]),
                        _vm._v(" off Best Available "),
                      ])
                    : _vm._e(),
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("keyboard_arrow_down"),
                  ]),
                  _vm.bestRate && _vm.showDynamicRate && _vm.hotel.dynamicRate
                    ? _c("span", { staticClass: "dyn" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.hotel.dynamicRate) +
                            "% off best available "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
            _vm.hotel.notes && _vm.hotel.notes.length
              ? _c(
                  "div",
                  { staticClass: "notes" },
                  _vm._l(_vm.hotel.notes, function (note) {
                    return _c("hotel-note", {
                      key: note.id,
                      attrs: { note: note, editable: false },
                    })
                  }),
                  1
                )
              : _vm._e(),
          ]
        : [
            _c("span", { staticClass: "actions" }, [
              _c(
                "i",
                {
                  staticClass: "material-icons screen",
                  on: {
                    click: function ($event) {
                      _vm.imageExpanded = !_vm.imageExpanded
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        !_vm.imageExpanded ? "fullscreen" : "fullscreen_exit"
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "i",
                { staticClass: "material-icons", on: { click: _vm.toggle } },
                [_vm._v("close")]
              ),
            ]),
            _c(
              "div",
              { staticStyle: { position: "relative" } },
              [
                _vm.hotel.company.logo
                  ? _c("img", {
                      staticClass: "logo",
                      attrs: {
                        src: `images/logos/${_vm.hotel.company.logo}`,
                        alt: "",
                        loading: "lazy",
                      },
                    })
                  : _vm._e(),
                _c("hotel-image", {
                  staticClass: "image",
                  class: { expanded: _vm.imageExpanded },
                  attrs: {
                    image: _vm.hotel.company.image
                      ? _vm.hotel.company.image.url
                      : "",
                  },
                  on: { click: _vm.toggle },
                }),
                _vm.isClosed
                  ? _c("div", { staticClass: "hotelClosed" }, [
                      _vm._v(" CLOSED "),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "columns" },
              [
                _c("div", { staticClass: "main column" }, [
                  _c(
                    "div",
                    [
                      _c("div", { staticClass: "hotel-name-container" }, [
                        _c(
                          "div",
                          {
                            staticClass: "hotel-name label",
                            class: { isClosed: _vm.isClosed },
                          },
                          [_vm._v(" " + _vm._s(_vm.hotel.company.name) + " ")]
                        ),
                        _vm.sustainability
                          ? _c("div", { staticClass: "sustainability" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.sustainability,
                                  alt: "Sustainable",
                                  loading: "eager",
                                },
                              }),
                            ])
                          : _vm._e(),
                      ]),
                      _vm.hasColumn("rating")
                        ? _c(
                            "rating",
                            {
                              staticClass: "data",
                              attrs: { rate: _vm.hotel.rating },
                            },
                            [
                              _vm._v("  ·  "),
                              _vm.hasColumn("address")
                                ? [_vm._v(" " + _vm._s(_vm.address) + " ")]
                                : _vm._e(),
                              _vm.hasColumn("address") && _vm.hasColumn("phone")
                                ? [_vm._v("  ·  ")]
                                : _vm._e(),
                              _vm.hasColumn("phone")
                                ? [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.hotel.company.phone) +
                                        " "
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _c("div", { staticClass: "data hotel-type" }, [
                            _c(
                              "div",
                              { staticClass: "address" },
                              [
                                _vm._v("  ·  "),
                                _vm.hasColumn("address")
                                  ? [_vm._v(" " + _vm._s(_vm.address) + " ")]
                                  : _vm._e(),
                                _vm.hasColumn("address") &&
                                _vm.hasColumn("phone")
                                  ? [_vm._v("  ·  ")]
                                  : _vm._e(),
                                _vm.hasColumn("phone")
                                  ? [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.hotel.company.phone) +
                                          " "
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]),
                    ],
                    1
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "button",
                      attrs: { href: _vm.directionsLink, target: "_blank" },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("location_on"),
                      ]),
                      _vm._v(" Directions "),
                      _vm.hasColumn("distanceMi")
                        ? [
                            _vm._v(
                              " (" +
                                _vm._s(
                                  parseFloat(
                                    _vm.hotel.analytics.distanceMi
                                  ).toFixed(2)
                                ) +
                                " Mi) "
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _vm.hasColumn("amenities")
                  ? _c(
                      "div",
                      { staticClass: "column amenities inline" },
                      _vm._l(_vm.amenitiesData, function (amenity) {
                        return _c(
                          "div",
                          {
                            key: amenity.abbr,
                            staticClass: "amenity",
                            class: {
                              active: _vm.amenities.indexOf(amenity.abbr) >= 0,
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons check" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.amenities.indexOf(amenity.abbr) >= 0
                                      ? "check"
                                      : "block"
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("span", { staticClass: "label" }, [
                              _vm._v(" " + _vm._s(amenity.name) + " "),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.hotel.notes && _vm.hotel.notes.length
                  ? _c(
                      "div",
                      { staticClass: "openedNotes" },
                      [
                        _c("div", { staticClass: "title" }, [_vm._v("Notes:")]),
                        _vm._l(_vm.hotel.notes, function (note) {
                          return _c("hotel-note", {
                            key: note.id,
                            attrs: { note: note, editable: false },
                          })
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "season-rates column" },
                  _vm._l(_vm.hotel.seasons, function (season, index) {
                    return _c("div", { key: index, staticClass: "season" }, [
                      _c("div", { staticClass: "title" }, [
                        _c(
                          "span",
                          { staticClass: "label" },
                          [
                            _vm._v(" Season " + _vm._s(index + 1) + " "),
                            season.start && season.end
                              ? [
                                  _vm._v(
                                    " (" +
                                      _vm._s(
                                        _vm.formatSeasonDate(season.start)
                                      ) +
                                      " - " +
                                      _vm._s(_vm.formatSeasonDate(season.end)) +
                                      ") "
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _c("span", { staticClass: "data" }, [
                          _vm._v(" " + _vm._s(_vm.hotel.currency) + " "),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "rates" },
                        [
                          _vm._l(season.rates, function (tRate, key) {
                            return [
                              _vm.showRate(key)
                                ? _c("div", { key: key, staticClass: "rate" }, [
                                    _c(
                                      "span",
                                      { staticClass: "label" },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.rateLabel(key)) + " "
                                        ),
                                        _vm.view.showRateTypes &&
                                        season.rateTypes &&
                                        season.rateTypes[key]
                                          ? [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    season.rateTypes[key]
                                                  ) +
                                                  ")"
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _c("span", { staticClass: "data" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(parseFloat(tRate).toFixed(2)) +
                                          " "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                    ])
                  }),
                  0
                ),
                _vm.showDynamicRate && _vm.hotel.dynamicRate
                  ? _c("div", { staticClass: "column" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("Dynamic Rate"),
                      ]),
                      _c("span", { staticClass: "data" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.hotel.dynamicRate) +
                            "% Off Best Available"
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._l(
                  _vm.columns.filter((col) => col.expanded),
                  function (column) {
                    return [
                      _vm.hasColumn(column.id) ||
                      (column.id === "code" && _vm.includedCode)
                        ? _c(
                            "div",
                            {
                              key: column.id,
                              staticClass: "column",
                              class: { [column.id]: true },
                            },
                            [
                              column.id === "code" && _vm.includedCode
                                ? _c("span", { staticClass: "label" }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.includedCode.text) + " "
                                    ),
                                  ])
                                : column.id === "distanceMi"
                                ? _c("span", { staticClass: "label" }, [
                                    _vm._v(
                                      " Distance from " +
                                        _vm._s(
                                          _vm.hotel.travelDestination.name
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _c("span", { staticClass: "label" }, [
                                    _vm._v(" " + _vm._s(column.text) + " "),
                                  ]),
                              column.id === "distanceMi"
                                ? _c("span", { staticClass: "data" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.get(column.key) &&
                                            _vm.get(column.key).toFixed(2)
                                        ) +
                                        " Mi "
                                    ),
                                  ])
                                : column.id === "code"
                                ? _c("span", { staticClass: "data" }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.includedCodeValue) + " "
                                    ),
                                  ])
                                : _c("span", { staticClass: "data" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getValue(column.key) || "-"
                                        ) +
                                        " "
                                    ),
                                  ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  }
                ),
                _vm.view.showBlackoutDates &&
                _vm.hotel.blackoutDates &&
                _vm.hotel.blackoutDates.length
                  ? _c(
                      "div",
                      { staticClass: "blackoutDates column" },
                      [
                        _c("div", [_vm._v("Blackout Dates")]),
                        _vm._l(
                          _vm.hotel.blackoutDates,
                          function (blackoutDate) {
                            return _c(
                              "div",
                              {
                                key: blackoutDate.start,
                                staticClass: "blackoutDate",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatSeasonDate(blackoutDate.start)
                                    ) +
                                    " - " +
                                    _vm._s(
                                      _vm.formatSeasonDate(blackoutDate.end)
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }